module.exports = __webpack_public_path__ + "faf01ea1b82dd3bb74af9a9d3111beb0.svg";